import * as landingsActions from './actions';
import landingsReducer from './reducer/index';
import * as landingsSelectors from './selectors';
export { landingsActions, landingsSelectors };

export * from './types';
export { default as landingsSaga } from './saga';
export default landingsReducer;
